import { exec } from 'node:child_process'
import as from 'ansis'

export async function runCommand(command: string, cwd?: string) {
  return new Promise((resolve, reject) => {
    const comm = exec(command, { cwd })

    comm.stdout?.pipe(process.stdout)
    comm.stderr?.pipe(process.stderr)

    comm.on('error', (err) => {
      as.redBright(err.message)
      reject(err)
    })
    comm.on('close', (code) => (code === 0 ? resolve(true) : reject(code)))
  })
}
